module.exports = __webpack_public_path__ + "../resources/img/ic_re_cancel_default.059c5ced.svg";